const initialState = {
    isReading: false,
    relationships: [],
    isUpdating: false,
    relationshipBeingUpdated: null
};

export default initialState;
